import { useLayoutEffect, useState } from "react";
function useContainerBreakpoint(thresholdPx, defaultValue = false, remeasureKey) {
    const [isAtOrAboveThreshold, setIsAtOrAboveThreshold] = useState(defaultValue);
    const [element, setElement] = useState(null);
    useLayoutEffect(()=>{
        if (!element) return;
        setIsAtOrAboveThreshold(element.getBoundingClientRect().width >= thresholdPx);
        const observer = new ResizeObserver(([entry])=>{
            if (entry) setIsAtOrAboveThreshold(entry.contentRect.width >= thresholdPx);
        });
        observer.observe(element);
        return ()=>observer.disconnect();
    }, [
        element,
        thresholdPx,
        remeasureKey
    ]);
    return [
        isAtOrAboveThreshold,
        setElement
    ];
}
export { useContainerBreakpoint };
